module.exports = __webpack_public_path__ + "img/cover.52edf1f2.jpg";